/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';

import { useLocation } from '@thd-olt-component-react/router';
import { QueryProvider } from '@thd-nucleus/data-sources';
import {
  Col, Row, Overlay
} from '@thd-olt-component-react/core-ui';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';

import ClearCallbackVerificationApiProvider from '../context/ClearCallbackVerificationApiContext';
import { ClearCallbackBody } from '../components/clear/ClearCallbackBody';
import { ClearPartnerWrapper } from '../components/clear/ClearPartnerWrapper';

import '../styles/pages/ClearVerification.scss';

export const ClearCallback = () => {
  const [opened, setOpened] = useState(true);

  const { search } = useLocation();

  const urlParams = new URLSearchParams(search.replace('#overlay', ''));
  const code = urlParams.get('code');
  const state = urlParams.get('state');
  const error = urlParams.get('error');
  const errorDescription = urlParams.get('errorDescription');

  useEffect(() => {
    if (code) {
      setOpened(true);
    }
  }, []);

  return (
    <QueryProvider
      cacheKey="rental-clear-verification"
    >
      <Row className="isBound">
        <ErrorBoundary name="breadcrumbs">
          <Col>
            <div className="breadcrumbs" style={{ display: 'flex', flexWrap: 'nowrap' }}>
              <a href="//www.homedepot.com/" className="link">Home</a><div className="breadcrumbs-spacer">/</div>
              <a href="//www.homedepot.com/c/tool_and_truck_rental" className="link">
                Tool Rental
              </a><div className="breadcrumbs-spacer">/</div>
              <a href="#" className="link">Clear Verification</a>
            </div>
          </Col>
        </ErrorBoundary>
        <ErrorBoundary name="zone-a">
          <Col>
            <div className="desktop-spacer" />
            <Overlay
              open={opened}
              onClose={() => {}}
              medium
            >
              <ClearCallbackVerificationApiProvider
                code={code}
                state={state}
                error={error}
                errorDescription={errorDescription}
              >
                <ClearPartnerWrapper>
                  <ClearCallbackBody />
                </ClearPartnerWrapper>
              </ClearCallbackVerificationApiProvider>
            </Overlay>
          </Col>
        </ErrorBoundary>
      </Row>
    </QueryProvider>
  );
};

ClearCallback.displayName = 'ClearCallbackPage';
ClearCallback.propTypes = {};
ClearCallback.defaultProps = {};
